// extracted by mini-css-extract-plugin
module.exports = {"root":"DomOseba_root__3_v2S","variant1":"DomOseba_variant1__2LHWR","variant2":"DomOseba_variant2__1beyZ"};